class MbCardGallery extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.slides = [...this.querySelectorAll('[data-mb-gallery-slide]')];
    if (this.slides.length < 2) return;
    this.controller = new AbortController();
    const options = {signal: this.controller.signal};
    this.index = 0;
    this.targetIndex = 0;
    this.request = 0;
    this.count = this.querySelector('[data-mb-gallery-current]');
    this.querySelector('[data-mb-gallery-prev]').addEventListener('click', () => this.show(this.targetIndex - 1), options);
    this.querySelector('[data-mb-gallery-next]').addEventListener('click', () => this.show(this.targetIndex + 1), options);
    this.addEventListener('keydown', (event) => {
      if (!event.target.closest('.mb-card-gallery__controls')) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.show(this.targetIndex + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    this.querySelector('.mb-card-gallery__controls').hidden = false;
  }

  async show(index) {
    const target = (index + this.slides.length) % this.slides.length;
    this.targetIndex = target;
    const request = ++this.request;
    const image = this.slides[target].querySelector('img');
    this.setAttribute('aria-busy', 'true');
    image.loading = 'eager';
    try {
      await image.decode();
    } catch {
      if (request === this.request) {
        this.targetIndex = this.index;
        this.setAttribute('aria-busy', 'false');
      }
      return;
    }
    if (!this.isConnected || request !== this.request) return;
    this.index = target;
    this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
    this.count.textContent = String(this.index + 1);
    this.setAttribute('aria-busy', 'false');
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.request++;
    this.controller = null;
  }
}

if (!customElements.get('mb-card-gallery')) customElements.define('mb-card-gallery', MbCardGallery);
